<template>
    <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <LineNotify msg="LineNotify"/>
    <Footer msg="Footer"/>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import LineNotify from "@/components/LineNotify.vue"
import Footer from '@/components/Footer.vue'

export default {
  name: "orders",
  components: {
    LineNotify,
    Footer
    
  }
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>